<p style="text-align: justify;">
    Al hacer click en confirmar está aceptando el plan de tratamiento y confirmando que BeAlign puede iniciar el
    proceso de manufactura de los alineadores o retenedores personalizados para este paciente. Al aceptar
    también está de acuerdo en pagar todos los cargos correspondientes y que el monto cobrado no serán
    reembolsable.
</p>